var placeSearch,
  autocomplete,
  map,
  marker,
  checkout,
  recogerTienda = false;
let dirdir, client;
var poligonosArr = [];
var dentroDeCobertura = false;
var tiendaBesoMenu = "";

function sinAcentos(palabra) {
  let comuna = palabra.toLowerCase();
  comuna = comuna.replace(new RegExp(/[àáâãäå]/g), "a");
  comuna = comuna.replace(new RegExp(/æ/g), "ae");
  comuna = comuna.replace(new RegExp(/ç/g), "c");
  comuna = comuna.replace(new RegExp(/[èéêë]/g), "e");
  comuna = comuna.replace(new RegExp(/[ìíîï]/g), "i");
  comuna = comuna.replace(new RegExp(/ñ/g), "n");
  comuna = comuna.replace(new RegExp(/[òóôõö]/g), "o");
  comuna = comuna.replace(new RegExp(/œ/g), "oe");
  comuna = comuna.replace(new RegExp(/[ùúûü]/g), "u");
  comuna = comuna.replace(new RegExp(/[ýÿ]/g), "y");
  return comuna;
}

function initAutocomplete() {
  var botonRevisar = document.getElementById("revisarCobertura");
  var query = document.getElementById("autocomplete");
  // Create the autocomplete object, restricting the search predictions to
  // geographical location types.
  autocomplete = new google.maps.places.Autocomplete(
    query,
    { types: ["geocode"] }
  );

  // Avoid paying for data that you don't need by restricting the set of
  // place fields that are returned to just the address components.
  autocomplete.setFields([
    "address_component",
    "formatted_address",
    "place_id",
    "url",
    "geometry",
  ]);

  // When the user selects an address from the drop-down, populate the
  // address fields in the form.
  autocomplete.addListener("place_changed", fillInAddress);

  botonRevisar.addEventListener("click", function() {
    var service = new google.maps.places.AutocompleteService();
    service.getQueryPredictions({ input: query.value }, function (predictions) {
      console.log(predictions)
      google.maps.event.trigger(autocomplete, "place_changed");
    });
    
  });
}

function geolocate() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      var geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      var circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocomplete.setBounds(circle.getBounds());
    });
  }
}

async function fillInAddress() {
  dentroDeCobertura = false;
  var place = autocomplete.getPlace();
  dirdir = place.address_components;
  // const selectedDir = document.getElementById("autocomplete").value;
  var botonPaago = document.getElementById("cart_submit");
  let botonContinuar = document.getElementById("continuarCompra");
  let textoOk = document.getElementById("textOk");
  let inputTienda = document.getElementById("tiendaBesomenu");
  var ciudadShipping = document.getElementById("ciudadShipping");
  var distritoShipping = document.getElementById("distritoShipping");
  var errorShipping = document.getElementById("errorShipping");

  errorShipping.style.display = "none";

  console.log(place);

  const numeroCalle = place.address_components.find((elemento) =>
    elemento.types.includes("street_number")
  );

  if (!numeroCalle) {
    errorShipping.style.display = "block";
    return;
  }

  const coord = {
    lat: place.geometry.location.lat(),
    lng: place.geometry.location.lng(),
  };

  const formattedAddress = place.formatted_address;

  document.getElementById("autocomplete").value = formattedAddress;
  ciudadShipping.value = place.address_components.find((ele) =>
    ele.types.includes("administrative_area_level_1")
  )?.long_name;
  distritoShipping.value = place.address_components.find((ele) =>
    ele.types.includes("locality")
  )?.long_name;

  const posision = new google.maps.LatLng(coord.lat, coord.lng);

  for (var l = 0; l < poligonosArr.length; l++) {
    if (
      google.maps.geometry.poly.containsLocation(
        posision,
        poligonosArr[l].poligono
      ) == true
    ) {
      dentroDeCobertura = true;
      tiendaBesoMenu = poligonosArr[l].name;
    }
  }

  if (marker) {
    marker.setMap(null);
  }

  marker = new google.maps.Marker({
    position: posision,
    title: "Tu Ubicación",
  });

  // To add the marker to the map, call setMap();
  marker.setMap(map);

  map.setCenter(posision);

  if (dentroDeCobertura) {
    console.log("Dentro")
    botonPaago.disabled = false;
    textoOk.innerText = textoOk.dataset.textoBien;
    textoOk.style.display = "block";
    inputTienda.value = tiendaBesoMenu;
  } else {
    botonPaago.disabled = true;
    textoOk.innerText = textoOk.dataset.textoError;
    textoOk.style.display = "block";
    inputTienda.value = "";
  }
}

async function initMap() {
  var cartform = document.getElementById("cartform");
  var botonPaago = document.getElementById("cart_submit");
  var botonPaago2 = document.getElementById("cart_submit_2");
  var cajaError = document.getElementById("coberturaBox");
  //var cajaErrorBesoTienda = document.getElementById("coberturaBoxBesoTienda"); //mamz
  var coberturaButtons = document.getElementById("coberturaButtons");
  var cajaMapa = document.getElementById("mapaCobertura");
  var deliveryCompra = document.getElementById("deliveryCompra");
  var botonContinuar = document.getElementById("continuarCompra");
  var continuarCompraRecoger = document.getElementById(
    "continuarCompraRecoger"
  );
  var interiorShipping = document.getElementById("interiorShipping");
  var nombreShipping = document.getElementById("nombeShipping");
  var apellidoShipping = document.getElementById("apellidoShipping");
  let textoOk = document.getElementById("textOk");
  var products = document.querySelectorAll(".producto-carrito");
  var seccionMenu = document.querySelectorAll(".seccion-besomenu");
  var seccionTienda = document.querySelectorAll(".seccion-besotienda");
  var hasComida = false;
  var hasTienda = false;
  client = ShopifyBuy.buildClient({
    domain: "beso-frances-creperia.myshopify.com",
    storefrontAccessToken: "24ea0460833e4cd95785e7defbeab031",
    language: "es-PE",
  });
  var currentCheckout = localStorage.getItem("checkout");
  var nombreLocalStorage = localStorage.getItem("@nombre");
  var apellidoLocalStorage = localStorage.getItem("@apellido");
  var interiorLocalStorage = localStorage.getItem("@int");

  if (nombreLocalStorage) {
    nombreShipping.value = nombreLocalStorage;
  }

  if (apellidoLocalStorage) {
    apellidoShipping.value = apellidoLocalStorage;
  }

  if (interiorLocalStorage) {
    interiorShipping.value = interiorLocalStorage;
  }

  if (!currentCheckout) {
    checkout = await client.checkout.create();
    localStorage.setItem("checkout", checkout.id);
  } else {
    checkout = await client.checkout.fetch(currentCheckout);

    if (checkout && checkout.completedAt) {
      checkout = await client.checkout.create();
      localStorage.setItem("checkout", checkout.id);
    }
  }

  products.forEach((product) => {
    let tags = product.dataset.productTags
      .split(",")
      .map((ttt) => ttt.trim().toLowerCase());
    hasComida = tags.includes("besomenu") || hasComida ? true : false;
    hasTienda = !tags.includes("besomenu") || hasTienda ? true : false;
  });

  if (hasComida) {
    botonPaago.disabled = true;
    coberturaButtons.style.display = "block";
  } else {
    seccionMenu.forEach((ele) => (ele.style.display = "none"));
    //botonPaago.style.display = "none";
    // botonPaago2.style.display = "inline";
  }

  if (!hasTienda) {
    seccionTienda.forEach((ele) => (ele.style.display = "none"));
    
  }

  /* deliveryCompra.addEventListener("click", () => {
    
    fetch(cajaError.dataset.mapurl)
      .then((respo) => respo.json())
      .then((data) => {
        for (var k = 0; k < data.length; k++) {
          var poligono = new google.maps.Polygon({
            paths: data[k].poligono,
            strokeColor: "#150B7E",
            strokeOpacity: 0.8,
            strokeWeight: 1,
            fillColor: "#150B7E",
            fillOpacity: 0.35,
          });

          let objeto = { name: data[k].name, poligono };

          poligonosArr.push(objeto);

          
        }

        //MAMZ12012021 if (hasComida) {
    		cajaError.style.display = "flex";
    		//cajaErrorBesoTienda.style.display = "flex";

          map = new google.maps.Map(cajaMapa, {
            center: new google.maps.LatLng(-12.1199978, -76.9976364),
            zoom: 12,
          });

          
        //MAMZ12012021}

        poligonosArr.forEach(pppp => pppp.poligono.setMap(map));

        initAutocomplete();
        
      })
      .catch((error) => {
        console.log(error);
        cajaError.style.display = "flex";
    	//cajaErrorBesoTienda.style.display = "flex"; //mamz 1501
      });

    
  }); */

  // cartform.addEventListener("submit", (e) => {
  //   e.preventDefault();
  //   console.log("Submit");
  // });

  // botonCancelar.addEventListener("click", function () {
  //   location.assign("/");
  // });

  // continuarCompraRecoger.addEventListener("click", function () {
  //   cajaError.style.display = "none";

  //   recogerTienda = true;
  //   cartform.submit();
  // });

  botonPaago.addEventListener("click", async function () {
    botonPaago.disabled = true;
    botonPaago.value = "Procesando...";

    try {
      if (!recogerTienda) {
        if (!nombreShipping.value || !apellidoShipping.value) {
          textoOk.innerText = "Llena todos los datos de envío para continuar";
          textoOk.style.display = "block";
          return;
        }

        localStorage.setItem("@nombre", nombreShipping.value);
        localStorage.setItem("@apellido", apellidoShipping.value);
        localStorage.setItem("@int", interiorShipping.value);

        cajaError.style.display = "none";
        //cajaErrorBesoTienda.style.display = "flex"; //mamz1501
        botonPaago.disabled = false;

        if (!dirdir) {
          throw new Error(
            "No se encontró la dirección, asegurate de haber ingresado calle y número"
          );
        }

        let numero = dirdir.find((ele) => ele.types.includes("street_number"))
          ?.long_name;
        let calle = dirdir.find((ele) => ele.types.includes("route"))
          ?.long_name;
        let distrito = dirdir.find((ele) => ele.types.includes("locality"))
          ?.long_name;
        let city = dirdir.find((ele) =>
          ele.types.includes("administrative_area_level_1")
        )?.long_name;

        const shippingAddress = {
          address1: `${calle} ${numero}`,
          address2: interiorShipping.value,
          city: city,
          company: null,
          country: "Peru",
          firstName: nombreShipping.value,
          lastName: apellidoShipping.value,
          phone: "",
          province: "Lima (departamento)",
          zip: sinAcentos(distrito),
        };

        const newCheckout = await client.checkout.updateShippingAddress(
          checkout.id,
          shippingAddress
        );

        console.log(newCheckout);
        // const finalCheckout = await client.checkout.updateEmail(
        //   checkout.id,
        //   correoShipping.value
        // );

        checkout = newCheckout;
      }

      const carrito = await fetch("/cart.js").then((json) => json.json());

      const lineItemsHandle = carrito.items.map((item) => item.handle);
      const promiseArr = lineItemsHandle.map((hand) => {
        console.log(hand)
        return client.product.fetchByHandle(hand);
      });

      const results = await Promise.all(promiseArr);

      console.log("resultados", results);

      if (checkout.lineItems.length > 0) {
        const idstoremove = checkout.lineItems.map((line) => line.id);

        const newCheckout = await client.checkout.removeLineItems(
          checkout.id,
          idstoremove
        );
      }

      const findedArray = results.map((prod) => {
        let variant;
       
        const cartItem = carrito.items.find(
          (carI) => carI.handle === prod.handle
        );

        if (!cartItem) {
          throw new Error("No se encontró producto en carrito " + prod.handle);
        }

        if (!cartItem.variant_title) {
          variant = prod.variants[0];
        } else {
          variant = prod.variants.find(
            (varian) => varian.title === cartItem.variant_title
          );
        }

        if (!variant) {
          throw new Error("No se encontró la variante de producto");
        }

        return {
          quantity: cartItem.quantity,
          variantId: variant.id,
        };
      });

      console.log(findedArray);
      const newCarr = await client.checkout.addLineItems(
        checkout.id,
        findedArray
      );
      const finalCart2 = await client.checkout.updateAttributes(checkout.id, {
        customAttributes: [
          {
            key: "Tienda Besomenu",
            value: document.getElementById("tiendaBesomenu").value,
          },
        ],
      });
      console.log(finalCart2);
      console.log(finalCart2.webUrl);

      let newDomain = `https://besofrances.com/${finalCart2.webUrl.substr(44)}`;

      location.assign(newDomain);

      // location.assign(`${checkout.webUrl}`);
    } catch (err) {
      console.log(err);
      botonPaago.disabled = false;
      botonPaago.value = "Intentar nuevamente";
    }
  });

  // botonContinuar.addEventListener("click", async function () {
  //   if (!nombreShipping.value || !apellidoShipping.value) {
  //     textoOk.innerText = "Llena todos los datos de envío para continuar";
  //     textoOk.style.display = "block";
  //     return;
  //   }

  //   cajaError.style.display = "none";
  //   botonPaago.disabled = false;

  //   if (!dirdir) {
  //     throw new Error(
  //       "No se encontró la dirección, asegurate de haber ingresado calle y número"
  //     );
  //   }

  //   let numero = dirdir.find((ele) => ele.types.includes("street_number"))
  //     ?.long_name;
  //   let calle = dirdir.find((ele) => ele.types.includes("route"))?.long_name;
  //   let distrito = dirdir.find((ele) => ele.types.includes("locality"))
  //     ?.long_name;
  //   let city = dirdir.find((ele) =>
  //     ele.types.includes("administrative_area_level_1")
  //   )?.long_name;

  //   const shippingAddress = {
  //     address1: `${calle} ${numero}`,
  //     address2: interiorShipping.value,
  //     city: city,
  //     company: null,
  //     country: "Peru",
  //     firstName: nombreShipping.value,
  //     lastName: apellidoShipping.value,
  //     phone: "",
  //     province: "Lima (departamento)",
  //     zip: sinAcentos(distrito),
  //   };

  //   const newCheckout = await client.checkout.updateShippingAddress(
  //     checkout.id,
  //     shippingAddress
  //   );

  //   console.log(newCheckout);
  //   // const finalCheckout = await client.checkout.updateEmail(
  //   //   checkout.id,
  //   //   correoShipping.value
  //   // );

  //   checkout = newCheckout;
  // });
}
